import axiosInstance from "./axiosInstance";

/**
 * ✅ สร้างคำขอใบเสนอราคาสำหรับ public users
 * ใช้กับปุ่ม “ขอใบเสนอราคา” ใน GlobalQuoteModal
 */
export const requestPublicQuote = async ({
  package_id,
  company,
  product_line,
  category,
  name,
  phone,
  note,
}) => {
  try {
    const payload = {
      package_id,
      company,
      product_line,
      category,
      name,
      phone,
      note,
    };

    console.log("📨 [quotes] POST /public/quotes", payload);
    const { data } = await axiosInstance.post("/public/quotes", payload);
    console.log("✅ [quotes] response:", data);
    return data;
  } catch (error) {
    console.error("❌ [quotes] requestPublicQuote error:", error?.response?.status, error?.message, error?.response?.data);
    throw error?.response?.data || error;
  }
};


/**
 * ✅ ดึงสถานะการ Sync ของ Quote (ถ้ามี future plan จะเช็กใน modal)
 */
export const fetchQuoteSyncStatus = async (packageId) => {
  if (!packageId) return null;
  try {
    const url = `/packages/${encodeURIComponent(packageId)}/sync-status`;
    console.log("🔄 [quotes] GET", url);
    const { data } = await axiosInstance.get(url);
    return data;
  } catch (error) {
    console.error("❌ [quotes] fetchQuoteSyncStatus error:", error?.response?.status, error?.message);
    return null;
  }
};
